/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_No_Event_SelectedInputs */

const en_error_nav_no_event_selected = /** @type {(inputs: Error_Nav_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No event selected`)
};

const fr_error_nav_no_event_selected = /** @type {(inputs: Error_Nav_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun evenement selectionne`)
};

const de_error_nav_no_event_selected = /** @type {(inputs: Error_Nav_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Veranstaltung ausgewählt`)
};

const it_error_nav_no_event_selected = /** @type {(inputs: Error_Nav_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento selezionato`)
};

const ru_error_nav_no_event_selected = /** @type {(inputs: Error_Nav_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие не выбрано`)
};

const es_error_nav_no_event_selected = /** @type {(inputs: Error_Nav_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ningún evento seleccionado`)
};

const zh_cn2_error_nav_no_event_selected = /** @type {(inputs: Error_Nav_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何事件`)
};

const ja_error_nav_no_event_selected = /** @type {(inputs: Error_Nav_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントが選択されていません`)
};

const hi_error_nav_no_event_selected = /** @type {(inputs: Error_Nav_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई इवेंट चयनित नहीं है`)
};

const pt_pt2_error_nav_no_event_selected = /** @type {(inputs: Error_Nav_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento selecionado`)
};

/**
* | output |
* | --- |
* | "No event selected" |
*
* @param {Error_Nav_No_Event_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_event_selected = /** @type {((inputs?: Error_Nav_No_Event_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Event_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_no_event_selected(inputs)
	if (locale === "de") return de_error_nav_no_event_selected(inputs)
	if (locale === "it") return it_error_nav_no_event_selected(inputs)
	if (locale === "ru") return ru_error_nav_no_event_selected(inputs)
	if (locale === "es") return es_error_nav_no_event_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_no_event_selected(inputs)
	if (locale === "ja") return ja_error_nav_no_event_selected(inputs)
	if (locale === "hi") return hi_error_nav_no_event_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_no_event_selected(inputs)
	return en_error_nav_no_event_selected(inputs)
});